import React, { Component } from "react";

export class Header extends Component {
  render() {
    return (
      <div>
        <header id="header" class="fixed-top">
          <div class="container">
            <div class="logo float-left">
              {/* <h1>
                <a href="index.html">NewBiz</a>
              </h1> */}
              <a href="/">
                <img src="assets/img/logo.png" alt="" class="img-fluid"></img>
              </a>
            </div>

            <nav class="main-nav float-right d-none d-lg-block">
              {/* <ul>
                <li>
                  <a href="/">HOME</a>
                </li>

                <li class="drop-down">
                  <a href="#">TAXATION</a>
                  <ul>
                    <li class="drop-down">
                      <a href="#">INCOME TAX</a>
                      <ul>
                        <li>
                          <a href="selfefiling">SELF E-FILING</a>
                        </li>
                        <li>
                          <a href="expertassistedefiling">EXPERT ASSISTED E-FILING</a>
                        </li>
                        <li>
                          <a href="premiumassistedefiling">PREMIUM ASSISTED E-FILING</a>
                        </li>
                        <li>
                          <a href="foreignincometaxfiling">FOREIGN INCOME TAX FILING</a>
                        </li>
                        <li>
                          <a href="taxconsultancy">TAX CONSULTANCY</a>
                        </li>
                        <li>
                          <a href="accounting">ACCOUNTING</a>
                        </li>
                      </ul>
                    </li>

                    <li class="drop-down">
                      <a href="#">GST</a>
                      <ul>
                        <li>
                          <a href="gstregistration">GST REGISTRATION</a>
                        </li>
                        <li>
                          <a href="gstreturnfiling">GST RETURN FILING</a>
                        </li>
                        <li>
                          <a href="gstadvisory">GST ADVISORY</a>
                        </li>
                        <li>
                          <a href="gstaudit">GST AUDIT</a>
                        </li>
                        <li>
                          <a href="gstassesment">GST ASSESMENT</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                <li class="drop-down">
                  <a href="#">COMPLIANCE</a>
                  <ul>
                    <li>
                      <a href="businessregistration">BUSINESS REGISTRATION</a>
                    </li>
                    <li>
                      <a href="trademarkandcopyrightregistration">
                      TRADEMARK AND COPYRIGHTS
                      </a>
                    </li>
                    <li>
                      <a href="corporatecompliance">CORPORATE COMPLIANCE</a>
                    </li>
                  </ul>
                </li>

                <li>
                  <a href="#">MUTUAL FUNDS</a>
                </li>

                <li class="drop-down">
                  <a href="insurance">INSURANCE</a>
                  <ul>
                    <li>
                      <a href="termlifeinsurance">TERM LIFE INSURANCE</a>
                    </li>
                    <li>
                      <a href="healthinsurance">HEALTH INSURANCE</a>
                    </li>
                    <li>
                      <a href="investmentplan">INVESTMENT PLAN</a>
                    </li>

                    <li>
                      <a href="carinsurance">CAR INSURANCE</a>
                    </li>
                    <li>
                      <a href="twowheelerinsurance">TWO WHEELER INSURANCE</a>
                    </li>
                    <li>
                      <a href="travelinsurance">TRAVEL INSURANCE</a>
                    </li>
                  </ul>
                </li>

                <li>
                  <a href="#">EQUITIES</a>
                </li>
                <li class="drop-down">
                  <a href="#">LOANS</a>
                  <ul>
                    <li>
                      <a href="personalloan">PERSONAL LOAN</a>
                    </li>
                    <li>
                      <a href="homeloan">HOME LOAN</a>
                    </li>
                    <li>
                      <a href="carloan">CAR LOAN</a>
                    </li>

                    <li>
                      <a href="twowheelerloan">TWO WHEELER LOAN</a>
                    </li>

                    <li>
                      <a href="educationloan">EDUCATION LOAN</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="invest">INVEST</a>
                </li>
                <li>
                  <a href="partner">PARTNER</a>
                </li>
                
              </ul>
              
              */}


<ul>
                <li>
                  <a href="/">HOME</a>
                </li>

                <li class="drop-down">
                  <a href="#">TAXATION</a>
                  <ul>
                    <li class="drop-down">
                      <a href="#">INCOME TAX</a>
                      <ul>
                        <li>
                          <a href="#">SELF E-FILING</a>
                        </li>
                        <li>
                          <a href="#">EXPERT ASSISTED E-FILING</a>
                        </li>
                        <li>
                          <a href="#">PREMIUM ASSISTED E-FILING</a>
                        </li>
                        <li>
                          <a href="#">FOREIGN INCOME TAX FILING</a>
                        </li>
                        <li>
                          <a href="#">TAX CONSULTANCY</a>
                        </li>
                        <li>
                          <a href="#">ACCOUNTING</a>
                        </li>
                      </ul>
                    </li>

                    <li class="drop-down">
                      <a href="#">GST</a>
                      <ul>
                        <li>
                          <a href="#">GST REGISTRATION</a>
                        </li>
                        <li>
                          <a href="#">GST RETURN FILING</a>
                        </li>
                        <li>
                          <a href="#">GST ADVISORY</a>
                        </li>
                        <li>
                          <a href="#">GST AUDIT</a>
                        </li>
                        <li>
                          <a href="#">GST ASSESMENT</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                <li class="drop-down">
                  <a href="#">COMPLIANCE</a>
                  <ul>
                    <li>
                      <a href="#">BUSINESS REGISTRATION</a>
                    </li>
                    <li>
                      <a href="#">
                      TRADEMARK AND COPYRIGHTS
                      </a>
                    </li>
                    <li>
                      <a href="#">CORPORATE COMPLIANCE</a>
                    </li>
                  </ul>
                </li>

                <li>
                  <a href="#">MUTUAL FUNDS</a>
                </li>

                <li class="drop-down">
                  <a href="#">INSURANCE</a>
                  <ul>
                    <li>
                      <a href="#">TERM LIFE INSURANCE</a>
                    </li>
                    <li>
                      <a href="#">HEALTH INSURANCE</a>
                    </li>
                    <li>
                      <a href="#">INVESTMENT PLAN</a>
                    </li>

                    <li>
                      <a href="#">CAR INSURANCE</a>
                    </li>
                    <li>
                      <a href="#">TWO WHEELER INSURANCE</a>
                    </li>
                    <li>
                      <a href="#">TRAVEL INSURANCE</a>
                    </li>
                  </ul>
                </li>

                <li>
                  <a href="#">EQUITIES</a>
                </li>
                <li class="drop-down">
                  <a href="#">LOANS</a>
                  <ul>
                    <li>
                      <a href="#">PERSONAL LOAN</a>
                    </li>
                    <li>
                      <a href="#">HOME LOAN</a>
                    </li>
                    <li>
                      <a href="#">CAR LOAN</a>
                    </li>

                    <li>
                      <a href="#">TWO WHEELER LOAN</a>
                    </li>

                    <li>
                      <a href="#">EDUCATION LOAN</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="#">INVEST</a>
                </li>
                <li>
                  <a href="#">PARTNER</a>
                </li>
                
              </ul>

            </nav>
          </div>
        </header>

        
      </div>
    );
  }
}

export default Header;
